module.exports = __webpack_public_path__ + "static/media/consulting.9ec1bb7b.svg";